import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH = 'api/adesao'

class DocumentosAdesaoApiClient {
	async buscarPaginada() {
		return new Promise((resolve) => {
			resolve({
				itens: [
					{
						id: 1,
						titulo: 'teste',
						tipoRegistroDocumento: 'DOC_EDITOR',
						situacao: 'CRIADO',
						idExternoDocumento: null,
						dataCadastro: '2023-12-04T19:19:43.11669Z',
						extensao: null,
						podeJuntar: false,
						podeAssinar: null,
						jaAssinou: false,
						possuiTermoDesentranhamento: 'NAO',
						idReferenciaTermoDesentranhamento: null,
						ehTermoDesentranhamento: 'NAO',
					},
				],
				totalPages: 1,
				totalElements: 1,
			})
		})
	}

	async buscarSignatariosDocumento(idDocumento) {
		return await axios.get(`${URL_PATH}/documentos/${idDocumento}/signatarios/buscar`)
	}

	async convidarSignatariosProcessoDigital(idDocumento, emailsSignatarios) {
		return await axios.post(`${URL_PATH}/documentos/${idDocumento}/signatarios/convidar`, {
			idDocumento,
			emailsSignatarios,
		})
	}

	async excluirSignatariosProcessoDigital(idDocumento, emailSignatario) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/documentos/${idDocumento}/signatarios/excluir`,
			filters: { emailSignatario, idDocumento },
		}).build()
		await axios.delete(url)
	}
}

export default new DocumentosAdesaoApiClient()
